import $ from 'jquery';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';
import 'picturefill';
import 'foreachfill';
import 'custom-event-polyfill';

// import './Libraries/LFM/BreakpointEvents';
import './Lightbox';
import './Select';
import './Menu';
import './Slider';
import './NavToggle';
import './Project';
import './NetworkPartners';
import './Forms';
// import './BackToTop';
// import './LazyLoad';
// import './Gallery';
import './Youtube';
// import './Maps';
// import './Accordion';
// import './Datepicker';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}
$(window).trigger('resize');  // trigger once on page load

if (document.cookie.match(/admin=1/) !== null) {
    // use with:
    // document.cookie = 'admin=1; path=/';

    Array.from(document.querySelectorAll('.language-menu')).forEach(elem => elem.removeAttribute('style'));
}
